import React from 'react'

const Fav=()=> {
   
    return (
      <div>
         <iframe
         frameBorder="0"
         width="400"
         height="50"
         src='https://drive.google.com/file/d/1k_uR_fTiu4qgpY9PogZdca7sZl8GXUKv/preview?usp=drivesdk' title="favSong"></iframe>
      </div>
      
    );
}

export default Fav
